import { FEATURE_TOGGLES } from '@/services/Configuration'

const { isLoggingEnabled } = FEATURE_TOGGLES ?? false

const baseLog = (level, ...args) => {
  if (isLoggingEnabled) {
    console[level](Date.now(), new Date(), ...args)
  }
}

export const debug = (...args) => baseLog('debug', ...args)

export const log = (...args) => baseLog('log', ...args)

export const error = (...args) => baseLog('error', ...args)

export const warn = (...args) => baseLog('warn', ...args)
